// Shared location-management i18n keys (used by LocationListing + LocationModal).
// Page-level keys live under `LocationListing.*` and `LocationModal.*`.

export const locationDict: Record<string, [en: string, th: string]> = {
  // ── Page-level keys (LocationListing) ───────────────────
  "LocationListing.pageTitle":  ["Locations", "ตำแหน่งจัดเก็บ"],
  "LocationListing.breadcrumb": ["Locations", "ตำแหน่งจัดเก็บ"],
  "LocationListing.search":     ["Search Locations", "ค้นหาตำแหน่ง..."],
  "LocationListing.empty":      ["No locations found", "ไม่พบตำแหน่งจัดเก็บ"],

  // ── Table column headers ────────────────────────────────
  "LocationListing.column.name":     ["Name",     "ชื่อ"],
  "LocationListing.column.type":     ["Type",     "ประเภท"],
  "LocationListing.column.capacity": ["Capacity", "ความจุ"],
  "LocationListing.column.qrCode":   ["QR Code",  "QR Code"],

  // ── Type labels (used as badge text in the Type column) ─
  "LocationListing.type.room":    ["Room / Zone", "ห้อง / โซน"],
  "LocationListing.type.rack":    ["Rack",        "แร็ค"],
  "LocationListing.type.shelf":   ["Shelf",       "ชั้นวาง"],
  "LocationListing.type.bin":     ["Bin",         "ช่อง"],
  "LocationListing.type.display": ["Display",     "ตู้โชว์"],

  // ── Capacity column formatting ──────────────────────────
  "LocationListing.capacity.value":    ["{n} bottles", "{n} ขวด"],
  "LocationListing.capacity.unlimited": ["Unlimited",   "ไม่จำกัด"],

  // ── Modal (LocationModal) ───────────────────────────────
  "LocationModal.title.add": ["Add New Location", "เพิ่มตำแหน่งจัดเก็บใหม่"],
  "LocationModal.title.edit": ["Edit Location",   "แก้ไขตำแหน่งจัดเก็บ"],

  "LocationModal.section.selectType": ["Select Location Type", "เลือกประเภทตำแหน่ง"],
  "LocationModal.section.generalInfo": ["General Info",         "ข้อมูลทั่วไป"],
  "LocationModal.section.identification": ["Identification",   "รหัสระบุ"],

  "LocationModal.type.room":  ["Room / Zone", "ห้อง / โซน"],
  "LocationModal.type.rack":  ["Rack",        "แร็ค"],
  "LocationModal.type.shelf": ["Shelf",       "ชั้นวาง"],

  "LocationModal.typeDesc.room":  ["Main area e.g. Stock, Basement", "พื้นที่หลัก เช่น ห้องสต็อก ห้องใต้ดิน"],
  "LocationModal.typeDesc.rack":  ["Wine fridge or large wooden rack", "ตู้แช่ไวน์หรือแร็คไม้ขนาดใหญ่"],
  "LocationModal.typeDesc.shelf": ["Specific shelf within a rack", "ชั้นวางเฉพาะภายในแร็ค"],

  "LocationModal.label.name":        ["Name",        "ชื่อ"],
  "LocationModal.label.locatedIn":   ["Located In",  "อยู่ภายใน"],
  "LocationModal.label.capacity":    ["Capacity",    "ความจุ"],
  "LocationModal.label.qrCode":      ["QR Code",     "QR Code"],
  "LocationModal.label.description": ["Description", "คำอธิบาย"],

  "LocationModal.placeholder.name":        ["e.g. Main Stock, Shelf A, Rack 1", "เช่น สต็อกหลัก, ชั้น A, แร็ค 1"],
  "LocationModal.placeholder.parent":     ["Select Parent Location (Optional)", "เลือกตำแหน่งหลัก (ไม่บังคับ)"],
  "LocationModal.placeholder.capacity":   ["Max bottles", "จำนวนขวดสูงสุด"],
  "LocationModal.placeholder.qrCode":     ["Scan or enter QR code", "สแกนหรือกรอก QR code"],
  "LocationModal.placeholder.description": ["Additional details to help find this location", "รายละเอียดเพิ่มเติมเพื่อช่วยค้นหาตำแหน่งนี้"],

  "LocationModal.hint.name":     ["Use a descriptive name like \"Main Wine Fridge\" or \"Rack A\"", "ใช้ชื่อที่อธิบายได้ดี เช่น \"ตู้แช่ไวน์หลัก\" หรือ \"แร็ค A\""],
  "LocationModal.hint.parentRoot":    ["Root location (e.g. Room, Stock). No parent required.", "ตำแหน่งราก (เช่น ห้อง, สต็อก) ไม่ต้องระบุตำแหน่งหลัก"],
  "LocationModal.hint.parentChild":   ["Select where this item is located (e.g. A Shelf must be inside a Room or Rack)", "เลือกว่ารายการนี้อยู่ที่ใด (เช่น ชั้นวางต้องอยู่ในห้องหรือแร็ค)"],
  "LocationModal.hint.capacity":      ["Leave empty or 0 for unlimited", "เว้นว่างหรือใส่ 0 หากไม่จำกัด"],
  "LocationModal.hint.qrCode":        ["Used for printing stickers. Staff can scan this code to move wines in/out.", "ใช้สำหรับพิมพ์สติกเกอร์ ทีมงานสแกนรหัสนี้เพื่อย้ายไวน์เข้า/ออก"],

  "LocationModal.autoGenerate": ["Auto-generate", "สร้างอัตโนมัติ"],
};
